//@ts-nocheck
'use client'

import React, { useContext, useEffect, useState, useRef } from 'react'
import 'swiper/css/effect-fade'
import * as S from './HeroTertiary.styles'
import { renderToStaticMarkup } from 'react-dom/server'
import useMediaQuery from '../../../../hooks/useMediaQuery'
import ItemsGrouped from '../../../molecules/ItemsGrouped/ItemsGrouped.component'
import { SpacerBase } from '../../../atoms/GridSystem'
import Icon from '../../../atoms/Icon/Icon.component'
import { Paragraph, Heading } from '../../../atoms/Typography/Typography.component'

import { Swiper, SwiperSlide } from 'swiper/react'
import {
  A11y,
  Pagination,
  Scrollbar,
  EffectFade,
  Autoplay,
} from 'swiper/modules'

import { SectionThemeContext } from '../../../../contexts/SectionTheme.context'

import Button from '../../../atoms/Button/Button.component'


const HeroTertiary = ({ sectionId = Math.random(), items }) => {
  const [isMobile, setIsMobile] = useState(useMediaQuery('(max-width: 1023px)'))
  const [swiper, setSwiper] = useState(null)
  const swiperRef = useRef(null)
  const paginationRef = useRef(null)
  const { selectedColorScheme } = useContext(SectionThemeContext)

  const handleCheckIsMobile = () => {
    if (!window) return false
    const width = window.innerWidth
    if (width <= 1023) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  const renderSlides = ({ items, colorScheme }) => {
    if (!Array.isArray(items)) return null

    return items.map((item, index) => (
      <SwiperSlide key={`HeroTertiarySlide-${index}-${item?.id}`}>
        <HeroTertiarySlide item={item} index={index} colorScheme={colorScheme} />
      </SwiperSlide>
    ))
  }

  const renderBullet = (index, className) => {
    return renderToStaticMarkup(
      <HeroTertiarySlidePaginationItem
        key={`HeroTertiarySlidePaginationItem-${index}`}
        className={className}
        index={index}
      />
    )
  }

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', handleCheckIsMobile)
    }

    () => {
      window.removeEventListener('resize', handleCheckIsMobile)
    }
  }, [])

  useEffect(() => {
    if (isMobile && swiper) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            swiper.autoplay?.resume()
          } else {
            swiper.autoplay?.pause()
          }
        })
      }, {
        rootMargin: '-7% 0px 0px 0px'
      })

      observer.observe(paginationRef.current)
    }
  }, [swiper])

  return (
    <S.HeroTertiary id={sectionId} colorScheme={selectedColorScheme}>
      <Swiper
        onSwiper={setSwiper}
        modules={[Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
        autoplay={{ delay: 5000 }}
        spaceBetween={28}
        slidesPerView={1}
        pagination={{
          el: '.swiper-pagination',
          clickable: true,
          renderBullet,
        }}
      >
        {renderSlides({ items, colorScheme: selectedColorScheme })}
      </Swiper>
      <S.HeroTertiarySlidePagination className="swiper-pagination" ref={paginationRef} colorScheme={selectedColorScheme}/>
    </S.HeroTertiary>
  )
}

const HeroTertiarySlidePaginationItem = ({ index, className }) => {
  return (
    <S.HeroTertiarySlidePaginationItem
      key={`HeroTertiarySlidePaginationItem-${index}`}
      className={className}
      aria-label={`Vai alla slide ${index + 1}`}
    />
  )
}

const HeroTertiarySlide = ({ item, index, colorScheme }) => {
  const { image, title, preTitle, subtitle, body, ctaPrimary, ctaTertiary } = item

  return (
    <S.HeroTertiarySlide>
      <S.HeroTertiaryContentWrapper>
        <S.HeroTertiaryContentInfos>
          <S.HeroTertiaryIconWrapper>
            <Icon name="leaf-green" useIconColor unlockedProportions />
          </S.HeroTertiaryIconWrapper>
          {preTitle ? (
            <>
              <Paragraph
                {...preTitle}
              />
              <SpacerBase xs={.5} />
            </>
          ) : null}
          {title ? (
            <>
              <Heading {...title} weight="regular" />
              <SpacerBase xs={2} />
            </>
          ) : null}
          {subtitle ? (
            <>
              <Paragraph
                {...subtitle}
              />
              <SpacerBase xs={3} lg={7} />
            </>
          ) : null}
        </S.HeroTertiaryContentInfos>
        {ctaPrimary || ctaTertiary ? (
          <ItemsGrouped
            direction={{ xs: "column", xl: "row" }} 
            space={{ xs: 16, xl: 24 }} 
            fullWidth={['xs', 'sm', 'md']}
            justify={{ xs: "center", xl: "flex-start" }}
            >
            {ctaPrimary ? (
              <Button {...ctaPrimary} variant="primary" iconEnd="arrow-right" />
            ) : null}
            {ctaTertiary ? (
              <Button
                {...ctaTertiary}
                variant="secondary"
                iconEnd="arrow-right"
              />
            ) : null}
          </ItemsGrouped>
        ) : null}
      </S.HeroTertiaryContentWrapper>
      <S.HeroTertiaryImageWrapper colorScheme={colorScheme} className={'image'}>
        {image ? (
          <S.HeroTertiaryImage
            src={image.url}
            alt={image.alternativeText}
            priority={index === 0}
            fill
          />
        ) : null}
      </S.HeroTertiaryImageWrapper>
    </S.HeroTertiarySlide>
  )
}

export default HeroTertiary
